export default "__VITE_ASSET__RyZdVd0d__ 100w";